import { EventProvider } from '../../config/networkConfig';
import { EventPayload } from '../../events';

export const NOT_FOUND = 'NOT_FOUND';

export default class StatusEventPayload implements EventPayload {
  provider?: EventProvider;

  status: string;

  constructor(status: string) {
    this.status = status;
  }
}
